import ErrorBoundary from '@sbt-web/error-boundary';
import { AdvertiserType } from '@sbt-web/network/types';
import React from 'react';
import BigCard from './BigCard.js';
import SmallCard from './SmallCard.js';
import { getCategoryFeaturesValues, getItemAvailability } from './utils/features.js';

const ItemCard = React.forwardRef(({ type, overrideUrgentLabelForPro, ...props }, ref) => {
    const { item, hideFavourite, imageVariant } = props;
    const ad = item;
    const featureList = getCategoryFeaturesValues(ad);
    const isItemAvailable = getItemAvailability(ad);
    const urgentLabelOverride = overrideUrgentLabelForPro && ad.advertiser.type === AdvertiserType.Pro
        ? 'Occasione'
        : undefined;
    try {
        return (React.createElement(ErrorBoundary, null, type === 'big' ? (React.createElement(BigCard, { ...props, featuresList: featureList, isItemAvailable: isItemAvailable, ref: ref, hideFavourite: hideFavourite, urgentLabelOverride: urgentLabelOverride })) : (React.createElement(SmallCard, { ...props, featuresList: featureList, isItemAvailable: isItemAvailable, ref: ref, hideFavourite: hideFavourite, imageVariant: imageVariant, urgentLabelOverride: urgentLabelOverride }))));
    }
    catch (e) {
        console.error(e);
        return null;
    }
});
ItemCard.displayName = 'ItemCard';

export { ItemCard, ItemCard as default };
//# sourceMappingURL=ItemCard.js.map
